import { createContext, useContext, useEffect, useState } from "react";
import api, { setUnauthorizedHandler } from "@/lib/api";

const LEGACY_KEY = "edikimou_token";   // older versions kept the token here

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [ready, setReady] = useState(false);
  const [mustChange, setMustChange] = useState(false); // login with a password below today's minimum

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(false));
    // A browser still holding the old token sends it once; the server swaps it for the cookie session.
    let legacy = null;
    try { legacy = localStorage.getItem(LEGACY_KEY); } catch (e) { /* storage blocked */ }
    api.get("/auth/me", legacy ? { headers: { Authorization: `Bearer ${legacy}` } } : undefined)
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => {
        try { localStorage.removeItem(LEGACY_KEY); } catch (e) { /* ignore */ }
        setReady(true);
      });
    return () => setUnauthorizedHandler(null);
  }, []);

  const auth = async (path, payload) => {
    const { data } = await api.post(`/auth/${path}`, payload);
    setUser(data.user);
    setMustChange(!!data.must_change_password);
    return data.user;
  };

  const login = (email, password) => auth("login", { email, password });
  const register = (name, email, password) => auth("register", { name, email, password });
  const logout = async () => { try { await api.post("/auth/logout"); } catch (e) { /* cookie expires anyway */ } setUser(false); };

  return (
    <AuthCtx.Provider value={{ user, setUser, ready, login, register, logout, mustChange, clearMustChange: () => setMustChange(false) }}>
      {children}
    </AuthCtx.Provider>
  );
}
